var map = {
	"./angular.svg": "6790",
	"./apple-safari.png": "1895",
	"./book.svg": "fc4e",
	"./bootstrap.svg": "6ea5",
	"./brush.svg": "3f92",
	"./doc.png": "4c2b",
	"./drive.png": "5f3f",
	"./dropbox.png": "c04a",
	"./figma.svg": "170a",
	"./file-icons/doc.png": "0443",
	"./file-icons/onedrive.png": "596c",
	"./file-icons/pdf.png": "8a4e",
	"./file-icons/psd.png": "9fa3",
	"./file-icons/sketch.png": "00e4",
	"./google-chrome.png": "76d3",
	"./icloud-1.png": "dfed",
	"./icloud.png": "9486",
	"./internet-explorer.png": "5741",
	"./internet.png": "9a19",
	"./jpg.png": "8a50",
	"./js.png": "64c3",
	"./json.png": "7a5d",
	"./manual-transaction.png": "997f",
	"./mozila-firefox.png": "c42e",
	"./onedrive.png": "a61a",
	"./onedrivenew.png": "ffc3",
	"./opera.png": "b1e1",
	"./parachute.svg": "c7f7",
	"./pdf.png": "15e3",
	"./picture-in-picture.png": "5fdb",
	"./psd.png": "3f0a",
	"./react.svg": "d598",
	"./rocket.svg": "6f49",
	"./sketch.png": "4053",
	"./speaker.svg": "5989",
	"./star.svg": "cc90",
	"./toolbox.svg": "f99d",
	"./txt.png": "7a18",
	"./unknown.png": "e749",
	"./vuejs.svg": "f445",
	"./w2w-transfer.png": "d333",
	"./xls.png": "ea42"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";